module.exports = __webpack_public_path__ + "img/send.12514338.svg";